// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/* eslint-disable */
// @ts-nocheck
import type * as Types from '@/graphql/schema';

import gql from '@/graphql/gql';
export type ScoreFragment = { __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean };

export const ScoreFragmentDoc = gql`
    fragment ScoreFragment on CasinoTournamentsPublicScore {
  id
  username
  points
  position
  isMyScore
  canClaimPrize
}
    `;
